import { Guid } from "@app/core/constants/constants";

export class DrawDetailHeaderModel {
    public profileImageTitle: string;
    public profileImageId: Guid;
    public profileImageUrl: string;
    public profileBackgroundImageUrl: string;
}
